import * as React from 'react';

import {
  List,
  Create,
  Edit,
  SimpleForm,
  ReferenceField,
  Datagrid,
  TextField,
  DateField,
  BooleanField,
  BooleanInput,
  ReferenceInput,
  AutocompleteInput,
  required,
} from 'react-admin';

export const DistributorEmailDomainList = (props) => (
  <List {...props}>
    <Datagrid rowClick="edit">
      <TextField source="id" />
      <BooleanField source="active" />
      <ReferenceField
        label="Distributor"
        source="distributorId"
        reference="distributors"
      >
        <TextField source="name" />
      </ReferenceField>
      <ReferenceField
        label="Email Domain"
        source="emaildomainId"
        reference="emaildomains"
      >
        <TextField source="email_domain" />
      </ReferenceField>
      <DateField source="createdAt" showTime />
      <DateField source="updatedAt" showTime />
    </Datagrid>
  </List>
);

export const DistributorEmailDomainCreate = (props) => (
  <Create {...props}>
    <SimpleForm>
      <BooleanInput source="active" />
      <ReferenceInput
        label="Distributor"
        source="distributorId"
        reference="distributors"
        filterToQuery={(searchText) => ({ name: searchText })}
        validate={required()}
      >
        <AutocompleteInput optionText="name" />
      </ReferenceInput>
    </SimpleForm>
  </Create>
);

export const DistributorEmailDomainEdit = (props) => (
  <Edit {...props}>
    <SimpleForm>
      <BooleanInput source="active" />
      <ReferenceInput
        label="Distributor"
        source="distributorId"
        reference="distributors"
        filterToQuery={(searchText) => ({ name: searchText })}
        validate={required()}
      >
        <AutocompleteInput optionText="name" />
      </ReferenceInput>
    </SimpleForm>
  </Edit>
);
